import { BusEvent } from '@web/common';

export class WarehouseReceiptCreatedBusEvent extends BusEvent {}
